/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Done_HintInputs */



/**
* | output |
* | --- |
* | "What the agent does with its result. Only apps you have connected are listed, and a dataset step lists only datasets you can write to." |
*
* @param {Agent_Wizard_Done_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_done_hint = /** @type {((inputs?: Agent_Wizard_Done_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Done_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was der Agent mit seinem Ergebnis macht. Es werden nur Apps angezeigt, die Sie verbunden haben, und ein Datensatz-Schritt bietet nur Datensätze an, in die Sie schreiben dürfen.")
	return /** @type {LocalizedString} */ ("What the agent does with its result. Only apps you have connected are listed, and a dataset step lists only datasets you can write to.")
});